/**
 * @tabler/icons-solidjs v2.32.0 - MIT
 */

import createSolidComponent from '../createSolidComponent.js';

var IconHexagonOff = createSolidComponent("hexagon-off", "IconHexagonOff", [
  [
    "path",
    {
      d: "M8.693 4.69l2.336 -1.39a2.056 2.056 0 0 1 2 0l6 3.573h-.029a2 2 0 0 1 1 1.747v6.536c0 .246 -.045 .485 -.13 .707m-2.16 1.847l-4.739 3.027a2 2 0 0 1 -1.942 0l-6 -3.833a2 2 0 0 1 -1.029 -1.747v-6.537a2 2 0 0 1 1.029 -1.748l1.154 -.687"
    }
  ],
  ["path", { d: "M3 3l18 18" }]
]);

export { IconHexagonOff as default };
//# sourceMappingURL=IconHexagonOff.js.map
